import script from "./DeleteAutomationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteAutomationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteAutomationDialog.vue?vue&type=style&index=0&id=ac8c5236&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac8c5236"]])